<template>
	<div>
		<div class="align-center d-flex justify-space-between pb-2">
			<h5>Important Dates</h5>
			<v-btn color="secondary" depressed icon small @click.stop="dialog = true">
				<v-icon small>mdi-dock-window</v-icon>
			</v-btn>
		</div>

		<v-row :no-gutters="$vuetify.breakpoint.mdAndUp">
			<v-col cols="12" md="6">
				<span class="grey--text text--darken-2 text-caption">
					Kickoff Date
				</span>
				<v-divider class="mb-2 opacity-50"></v-divider>
				<span class="font-weight-bold text-caption">
					{{ activationDate }}
				</span>
			</v-col>
			<v-col class="text-md-right" cols="12" md="6">
				<span class="grey--text text--darken-2 text-caption">
					Launch Date
				</span>
				<v-divider class="mb-2 opacity-50"></v-divider>
				<span class="font-weight-bold text-caption">
					{{ launchDate }}
				</span>
			</v-col>
		</v-row>

		<v-dialog v-model="dialog" content-class="rounded-xl" scrollable width="600px">
			<v-card class="position-relative" rounded="xl">
				<v-card-title class="d-flex justify-space-between">
					<h5>Important Dates</h5>
					<v-btn
							class="mt-n1 me-n2"
							color="primary"
							depressed
							icon
							@click="dialog = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row v-if="hasLaunchDate && -1 < launchDaysRemaining < 15">
						<v-col>
							<v-alert
									v-if="launchDaysRemaining !== 0"
									dense
									:icon="launchDaysRemaining >= 1 ? 'mdi-alert' : 'mdi-check-circle'"
									outlined
									:type="launchDaysRemaining >= 1 ? 'warning' : 'success'"
							>
								<div v-if="launchDaysRemaining >= 1" class="text-body-2">
									This pass is launching in {{ launchDaysRemaining }} days. Be sure to
									complete your checklist of required items to be included!
								</div>
								<div v-else-if="launchDaysRemaining === 0" class="text-body-2">
									This pass is launching today. Good luck!
								</div>
								<div v-else class="text-body-2">
									This pass launched {{ launchDaysRemaining * -1 }}
									day{{ launchDaysRemaining === -1 ? '' : 's' }} ago. Check in often to
									see how your offer(s) are performing.
								</div>
							</v-alert>
							<v-alert
									v-else
									color="success"
									dense
									icon="mdi-party-popper"
									outlined
									prominent
							>
								Congrats! Today is 'Launch Day.' Get ready for increased foot traffic and
								sales!
							</v-alert>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="4">Kickoff Date</v-col>
						<v-col cols="8">
							<div class="font-weight-bold grey--text mb-2 text--darken-1">
								{{ activationDate }}
							</div>
							<div class="text-caption">
								This is the date the pass build and outreach to venues was officially
								started.
							</div>
						</v-col>
					</v-row>
					<v-divider class="my-4 opacity-50"></v-divider>
					<v-row>
						<v-col cols="4">Launch Date</v-col>
						<v-col cols="8">
							<div class="font-weight-bold grey--text mb-2 text--darken-1">
								{{ launchDate }}
							</div>
							<div class="text-caption">
								This is the date the pass will be live to customers.
							</div>
						</v-col>
					</v-row>
					<v-divider v-if="endDate" class="my-4 opacity-50"></v-divider>
					<v-row v-if="endDate">
						<v-col cols="4">End Date</v-col>
						<v-col cols="8">
							<div
									class="font-weight-bold mb-2"
									:class="endDate === 'TBD' ? 'error--text' : 'grey--text text--darken-1'"
							>
								{{ endDate }}
							</div>
							<div class="text-caption">
								This is the date the pass will officially end and redemptions will no
								longer be possible.
							</div>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'PassDates',
	props: {
		invite: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			dialog: false
		};
	},
	computed: {
		dateFormat() {
			return this.$vuetify.breakpoint.smAndDown ? 'll' : 'LL';	
		},
		endDate() {
			if(!this.invite?.end_date || this.invite.end_date === '0000-00-00 00:00:00')
				return false;
			// Determine the date format instead of hardcoding below...
			return this.moment(this.invite.end_date).format('LL');
		},
		hasLaunchDate() {
			return !!this.invite?.launch_date;
		},
		activationDate() {
			return this.formattedDate(this.invite?.activationDate);
		},
		launchDate() {
			return this.formattedDate(this.invite?.launch_date);
		},
		launchDaysRemaining() {
			if(!this.hasLaunchDate) return -1;
			const launchDay = this.moment(this.invite.launch_date).startOf('day');
			const today = this.moment().startOf('day');
			return launchDay.diff(today, 'days');
		}
	},
	methods: {
		formattedDate: function (dateValue) {
			if (!dateValue || dateValue === '0000-00-00 00:00:00')
				return 'TBD';
			return this.moment(dateValue).format(this.dateFormat);
		}
	}
};
</script>

<style lang="scss" scoped></style>
